import type { ApiGenericResponse, Service } from '../../typings'

export function getFeaturedServicesAction<T = ApiGenericResponse<Service[]>>(): Promise<T> {
  const { api } = useApi()
  return api.get<T>('/v2/services/featured')
}
